<template>
    <div class="flex month" :style="`height: ${ASSETS.Timeline.MonthHeight(CONFIG)}`">
        <Year
            v-for="(year, y) in years"
            :key="y"
            :year="year"
            :priority="priority"
        />
    </div>
</template>

<script>
import Year from "@/components/Timeline/Year.vue";
import { ASSETS } from "@/assets/JS/Assets.js";
import { CONFIG } from "@/assets/JS/Config.js";

export default {
    name: "TimelineMonth",
    props: {
        years: Array,
        priority: Object
    },
    components: { Year },
    data: () => ({
        ASSETS,
        CONFIG
    })
};
</script>